import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {useTheme} from 'react-jss';
import isUsingArtemisStyles from '../../v2/selectors/isUsingArtemisStyles';
import bigQueryMetricRecorder from '../../v2/tracking/bigQueryMetricRecorder';
import propsToClassName from '../../v2/utils/propsToClassName';
import Track from '../../v2/utils/tracking';
import useStyles from './Button.styles';

export function Button(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  const handleClick = (event) => {
    try {
      bigQueryMetricRecorder('Button', [{name: 'ButtonId', value: props.id}]);
    } catch (error) {
      Track.track(error);
    }
    
    if (props.onClick) {
      event.preventDefault();
      props.onClick(event);
    }
  };
  
  const Tag = props.href ? 'a' : 'button';
  return (
    <Tag
      id={props.id}
      className={`${classes.button} ${propsToClassName(props, 'Button',
        ['primary', 'fullWidth', 'textOnly', 'large', 'link', 'noResize', 'horizontalAlign',
          'round', 'noStyle', 'leftAlign'])} ${props.className}`}
      type={props.type}
      name={props.name}
      disabled={props.disabled}
      role="button"
      tabIndex="0"
      href={props.href}
      onClick={handleClick}
      onMouseDown={props.onMouseDown}
      aria-describedby={props.describedBy}
      target={(props.href && !props.noNewTab) ? '_blank' : null}
      aria-label={props.ariaLabel}
      aria-hidden={props.ariaHidden}
      data-test={props['data-test']}
      aria-expanded={props.ariaExpanded}
    >
      {!props.isUsingArtemisStyles && <div className="Button--focus" />}
      {props.icon && <span className={`Button__icon ${classes.icon}`}>{props.icon}</span>}
      {props.iconLeft && <span data-test="Button__icon-left" className={classes.iconLeft}>{props.iconLeft}</span>}
      {props.children}
      {props.iconRight && <span data-test="Button__icon-right" className={classes.iconRight}>{props.iconRight}</span>}
    </Tag>
  );
}

Button.propTypes = {
  isUsingArtemisStyles: PropTypes.bool,
  id: PropTypes.string.isRequired,
  primary: PropTypes.bool,
  fullWidth: PropTypes.bool,
  textOnly: PropTypes.bool,
  noStyle: PropTypes.bool,
  leftAlign: PropTypes.bool,
  large: PropTypes.bool,
  link: PropTypes.bool,
  round: PropTypes.bool,
  noResize: PropTypes.bool,
  maxContent: PropTypes.bool,
  horizontalAlign: PropTypes.bool,
  className: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  href: PropTypes.string,
  describedBy: PropTypes.string,
  ariaLabel: PropTypes.string,
  ariaHidden: PropTypes.bool,
  ariaExpanded: PropTypes.bool,
  inLineIcon: PropTypes.bool,
  icon: PropTypes.node,
  iconLeft: PropTypes.node,
  iconRight: PropTypes.node,
  'data-test': PropTypes.string,
  noNewTab: PropTypes.bool,
};

Button.defaultProps = {
  disabled: false,
  link: false,
  round: false,
  noStyle: false,
  leftAlign: false,
  type: 'button',
  onClick: null,
  href: null,
  describedBy: null,
  ariaLabel: null,
  ariaHidden: false,
  icon: null,
  iconLeft: null,
  iconRight: null,
  className: '',
  ariaExpanded: undefined,
  noNewTab: false,
};

const mapStateToProps = state => ({
  isUsingArtemisStyles: isUsingArtemisStyles(state),
});

export default connect(mapStateToProps)(Button);
